import {
   AfterViewInit,
   Component,
   ElementRef,
   EventEmitter,
   Input,
   OnChanges,
   OnInit,
   Output,
   SimpleChanges,
   ViewChild
} from '@angular/core';
import {UntypedFormControl} from "@angular/forms";
import {ServerService} from "../../../services/server.service";
import {DialogService} from "../dialog/dialog.service";


@Component({
   selector: 'app-barcode-input',
   templateUrl: './barcode-input.component.html',
   styleUrls: ['./barcode-input.component.scss']
})
export class BarcodeInputComponent implements OnInit, AfterViewInit, OnChanges {
   @ViewChild('search', {static: true}) search!: ElementRef

   @Input() appearance: any = 'standard';
   @Input() url: string = '';
   @Input() name: string = ''
   @Input() placeholder: string = '';
   @Input() disable: boolean = false;
   @Input() inputCtrl: UntypedFormControl = new UntypedFormControl();
   @Input() classObject: any;
   @Input() showIcon: boolean = false;
   @Input() autofocus: boolean = false;

   @Input() requestValue: boolean = true

   @Output() outputValue = new EventEmitter<any>();

   barcode = '';

   constructor(private serverSrv: ServerService,
               private dialogSrv: DialogService) {
   }

   ngOnInit(): void {
      if (this.autofocus) this.search.nativeElement.focus();
   }

   ngAfterViewInit(): void {
      // if (this.disable) this.inputCtrl.disable()
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (this.disable) this.inputCtrl.disable()
      else this.inputCtrl.enable()
   }

   searchValues(){
      let val = this.barcode.toString().padEnd(13, '0')
      let barcode = this.barcode
      if (this.requestValue){
         this.serverSrv.get(this.classObject, this.url + val + '&ean='+ this.barcode)
            .then(res => {
               this.barcode = ''
               this.outputValue.emit([val, res, barcode]);
            })
            .catch(err => {
               this.barcode = ''
               console.error(err);
               this.dialogSrv.showToastError({err: err, msg:"Errore Prodotto"});
            })
      }else {
         this.outputValue.emit(val);
      }

   }

}
